import { ApolloLink } from "@apollo/client";
import { AxiosResponse } from "axios";
import { NavigateFunction } from "react-router-dom";
import { toast } from "react-toastify";
import { LoginErrors } from "../constants/auth0";
import { triggerSessionExpired } from "../strict/app/AppOverlayController";

const LOGIN_ERROR_VALUES = new Set<string>(Object.values(LoginErrors));

/**
 * Handles a recognized LoginErrors code (overlay / navigate / toast) and returns true; false otherwise.
 * An invalid/expired token routes to the session-expired overlay rather than a full-page logout.
 */
export const handleLoginErrorCode = (code: string, navigate: NavigateFunction): boolean => {
  if (!LOGIN_ERROR_VALUES.has(code)) return false;
  switch (code as LoginErrors) {
    case LoginErrors.INVALID_TOKEN:
      triggerSessionExpired();
      break;
    case LoginErrors.EMAIL_NOT_RECOGNIZED:
      void navigate("/error"); // /error is actually the "Not authorized" page.
      break;
    case LoginErrors.EMAIL_NOT_AUTHORIZED:
      toast.error("Not authorized");
      break;
  }
  return true;
};

export const validateAuth0ApiErrors = (response: AxiosResponse | ApolloLink.Result, navigate: NavigateFunction) => {
  if (!response.data || typeof response.data !== "object" || !("errors" in response.data)) return;
  const errorCode = response.data.errors[0].extensions.code;
  handleLoginErrorCode(errorCode, navigate);
};
